import { selectFromRoutePaginatedDto } from '../../models';
import RouteOverviewExtraQuery from './RouteOverviewExtraQuery';

export default selectFromRoutePaginatedDto()
  .hasNextPage
  .edges(b => b.node(RouteOverviewExtraQuery))
  .toString();
